import { GMetrixTable } from 'components/GMetrixTable/GMetrixTable';
import { useExtendOrder } from 'pages/orders/extend_order/context';
import { FormattedMessage, useIntl } from 'react-intl';
import { getFormattedDateApi } from 'utils';
import { Button } from 'react-bootstrap';

export const SelectStep = props => {

    const { handleSelectOrder, loading, orders, partnerName } = useExtendOrder();
    const { formatMessage } = useIntl();

    return (
        <div className={'select-step d-flex flex-column gap-3'}>
            <h6>
                <FormattedMessage defaultMessage="Select an order to extend for" id="select_an_order_to_extend_for.bbfdb12b" />
                {' '}
                <em className="fw-bold">
                    {partnerName}
                </em>
            </h6>
            <GMetrixTable
                columnData={[
                    { field: 'Name', title: formatMessage({ id: 'name.5458f379', defaultMessage: 'Name' }) },
                    { field: 'OrderControl', title: formatMessage({ id: 'order_id.ab576b3d', defaultMessage: 'Order ID', description: 'Formulario' }) },
                    { cell: data => (
                        <td>
                            {getFormattedDateApi(new Date(data.dataItem.DateCreate))}
                        </td>
                    ), field: 'DateCreate', title: formatMessage({ id: 'created.8d9f8791', defaultMessage: 'Created' }) },
                    { cell: data => (
                        <td>
                            {getFormattedDateApi(new Date(data.dataItem.DateExpire))}
                        </td>
                    ), field: 'DateExpire', title: formatMessage({ id: 'expires.84d49534', defaultMessage: 'Expires' }) },
                    { field: 'OrderedBy', title: formatMessage({ id: 'ordered_by.381902ec', defaultMessage: 'Ordered By', description: 'Formulario' }) },
                    { field: 'NumGranted', title: formatMessage({ id: 'assigned.f0b32a15', defaultMessage: 'Assigned' }) },
                    { field: 'NumAvailable', title: formatMessage({ id: 'available.d321561a', defaultMessage: 'Available' }) },
                    { field: 'Comment', title: formatMessage({ id: 'comment.252dd7a3', defaultMessage: 'Comment', description: 'Formulario' }) },
                    {
                        cell: data => (
                            <td>
                                <Button onClick={() => handleSelectOrder(data.dataItem)}>
                                    <FormattedMessage defaultMessage="Select" id="select.57e6e9c7" />
                                </Button>
                            </td>
                        ),
                        field: '',
                        title: '',
                        width: '100px'
                    }
                ]}
                loading={loading}
                rowData={orders}
            />
        </div>
    );

};
